<ul class="navbar">
  <li class="nav-item active">
    <a class="nav-link" (click)="save_chondoituong()">
      <i style="color:red" class="fa-2x mr-2 far fa-window-close"></i>
      Thoát 
    </a>
  </li>
  <!--<li class="nav-item">
    <a class="nav-link" (click)="closeModal_chondoituong()">
      <i class="fa-2x mr-2 fa fa-window-close">
      </i>
      Thoát
    </a>
  </li>-->
</ul>


<div class="row">
  <div class="col-9">
    <label class="control-label" style="font-weight:bold;color:cornflowerblue">Danh sách lịch học</label>
  </div>
  <div class="col-3">
    <button *ngIf="quyen_them===true" style="float:right" class="btn btn-info btn-bloc" (click)="adddata()">
      Thêm mới
    </button>
  </div>
</div>

<!-- lưới chi tiết -->
<div style="padding: 2px 10px 10px 10px;color:black !important;height: calc(100vh - 150px)">
  <div class="row">
    <table class="table table-striped table-bordered table-hover table-condensed">
      <thead [ngClass]="{'theadcss': totalItems>16}">
        <!--<thead>-->
        <tr>
          <th style="width:100px;text-align:center;background-color:#f3f8fc">Thứ tự</th>
          <th style="width:100px;text-align:center;background-color:#f3f8fc">Thứ</th>
          <th style="width:100px;text-align:center;background-color:#f3f8fc">Từ</th>
          <th style="width:100px;text-align:center;background-color:#f3f8fc">Đến</th>
          <th style="width:100px;text-align:center;background-color:#f3f8fc">Phòng</th>
          <th style="text-align:center;background-color:#f3f8fc">Ghi chú</th>
          <th style="width:100px;text-align:center">Chức năng</th>

        </tr>

       

      </thead>
      <tbody style="height:calc(100vh - 210px);">
        <tr *ngFor="let u of datas">
          <td style="width:100px;text-align:center"><a (click)="editdata(u)">{{u.STT}}</a></td>
          <td style="width:100px"><a (click)="editdata(u)">{{u.Thu}}</a></td>
          <td style="width:100px"><a (click)="editdata(u)">{{u.TuGio}}</a></td>
          <td style="width:100px"><a (click)="editdata(u)">{{u.DenGio}}</a></td>
          <td style="width:100px"><a (click)="editdata(u)">{{u.PhongHoc}}</a></td>
          <td>{{u.GhiChu}}</td>
          <td style="width:100px;text-align:center">
            <a href="#" class="mb-1 far fa-trash-alt ng2-smart-action ng2-smart-action-custom-custom ng-star-inserted" (click)="deleterow(u)"> {{'Xóa' | translate}}</a>
          </td>

        </tr>
      </tbody>
    </table>


  </div>

</div>





<div class="modal-footer" style="display: flex;justify-content: space-between;margin-top:5px;">
  <div>
    <div *ngIf="totalItems>=10">
      <ul class="pagination">
        <li [ngClass]="{disabled: currentPage === 1}">
          <a (click)="setPage(1)"><<</a>
        </li>
        <li [ngClass]="{disabled:currentPage === totalPages}">
          <a (click)="setPage(currentPage + 1)">></a>
        </li>
        <li *ngFor="let page of pages" [ngClass]="{active: currentPage === page.Id}">
          <a (click)="setPage(page.Id)">{{page.Id}}</a>
        </li>
        <li [ngClass]="{disabled:currentPage === 1}">
          <a (click)="setPage(currentPage - 1)"><</a>
        </li>
        <li [ngClass]="{disabled:currentPage === totalPages}">
          <a (click)="setPage(totalPages)">>></a>
        </li>
        <li>
          <input type="number" style="width:50px;height:25px;text-align:center" [(ngModel)]="pageSize" (blur)="search1()" />
        </li>
        <li><span style="font-weight:bold">Tổng số: {{totalItems | number}}</span></li>
      </ul>
    </div>
  </div>
  <div class="">

  </div>

</div>



<bs-modal #mdKhachHang class="modal fade show in" [cssClass]="'modal6'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title">{{modalTitle}}</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="mdKhachHang.close()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <bs-modal-body>
    <app-daotao-lichhocedit #khachhangedit (save)="saveModal($event)"></app-daotao-lichhocedit>
  </bs-modal-body>
</bs-modal>





